import type { ComponentSchema, FieldSchema } from '../../../../../schema-types'
import { SUPPORTED_PAGES } from '../../_builder-constants'

/** Icons the header's quick-link buttons can show (drawn by the theme's chrome icon set). */
const QUICK_LINK_ICONS = [
  { label: 'Tag (offers)', value: 'tag' },
  { label: 'Wrench (tools)', value: 'wrench' },
  { label: 'Monitor (PC builder)', value: 'monitor' },
  { label: 'Chip', value: 'cpu' },
  { label: 'Lightning', value: 'zap' },
  { label: 'Truck', value: 'truck' },
  { label: 'Headset', value: 'headset' },
  { label: 'Grid', value: 'grid' },
]

const QUICK_LINK_SCHEMA: FieldSchema[] = [
  { key: 'label', label: 'Label', type: 'string' },
  { key: 'url', label: 'Link URL', type: 'string', placeholder: '/offers' },
  { key: 'icon', label: 'Icon', type: 'select', options: QUICK_LINK_ICONS, default: 'tag' },
]

/**
 * Projukti header: a graphite bar (logo, wide search, quick-link buttons, compare / wishlist / cart and login)
 * over a white category bar whose items open a mega panel. The category bar lists the store's categories marked
 * for the menu bar, so it has no settings of its own.
 */
export const schema: ComponentSchema = {
  type: 'header',
  label: 'Header',
  description: 'Logo, search, quick-link buttons, shopper icons and the category bar.',
  supportedPages: [...SUPPORTED_PAGES],
  variants: [{ id: 'v1', label: 'Graphite bar with a category bar' }],
  commonFields: [
    { key: 'logo.src', label: 'Logo', type: 'image', help: 'Shown on a white tile on the dark bar.' },
    { key: 'logo.alt', label: 'Logo alt text', type: 'string' },
    { key: 'searchPlaceholder', label: 'Search placeholder', type: 'string', placeholder: 'Search laptops, parts, brands or models…' },
    {
      key: 'quickLinks',
      label: 'Quick-link buttons',
      type: 'array',
      help: 'The outlined buttons beside the search (up to three). Empty = Offers, Tools and PC Builder.',
      itemSchema: QUICK_LINK_SCHEMA,
    },
    {
      key: 'actions',
      label: 'Icons',
      type: 'object',
      fields: [
        { key: 'showSearch', label: 'Search', type: 'boolean', default: true },
        { key: 'showCompare', label: 'Compare', type: 'boolean', default: true },
        { key: 'showWishlist', label: 'Wishlist', type: 'boolean', default: true },
        { key: 'showCart', label: 'Cart', type: 'boolean', default: true },
        { key: 'showAccount', label: 'Login / account', type: 'boolean', default: true },
        {
          key: 'cartAction',
          label: 'Cart opens',
          type: 'select',
          options: [
            { label: 'Cart drawer', value: 'sidebar' },
            { label: 'Cart page', value: 'page' },
          ],
          default: 'sidebar',
        },
      ],
    },
  ],
}
